export default {
    CONFIRMED: 'Confirmed',
    CANCELLED: 'Cancelled',
    HELD: 'Held',
    PAST: 'Past',
    QUOTE: 'Quote',
    PENDING_CONFIRMATION: 'Pending Confirmation',
    ENROUTE: 'Enroute',
};



// WEBPACK FOOTER //
// ./src/app/modules/trip/trip-statuses.js